import { z } from 'zod';
import { ShortfallAction } from '../../constants/shortfall-action.js';
import { requiredUuidString } from '../zod-helpers/index.js';
import { MAX_LINE_QTY, MIN_STORABLE_QTY } from './item-quantity.js';
// availableQty is applied as a line's quantity (0 deletes the line) and the submit refuses when less is available now.
export const submitShortfallChoiceSchema = z.object({
    action: z.enum(ShortfallAction, 'Choose what to do with the unavailable quantity.'),
    availableQty: z
        .number('Available quantity must be a number.')
        .min(0, 'Available quantity cannot be negative.')
        .max(MAX_LINE_QTY, 'Available quantity must be 1,000,000,000 or less.')
        .refine((qty) => qty === 0 || qty >= MIN_STORABLE_QTY, 'Available quantity must be 0 or at least 0.000000001.'),
});
export const submitShortfallItemChoiceSchema = submitShortfallChoiceSchema.extend({
    salesOrderItemId: requiredUuidString('Sales order line is required.', 'Invalid sales order line selection.'),
});
//# sourceMappingURL=submit-shortfall-choice-input.js.map